// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpis {
    padding: 2rem 0;
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    flex-wrap: wrap;
}

.kpi-item {
    flex: 1 1;
    min-width: 280px;
    padding: 2rem;
    border-radius: 16px;
    background: #FFFFFF;
    border: 2px solid #FCCC4D;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.kpi-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(252, 204, 77, 0.15);
}

.kpi-icon {
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.kpi-icon img {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.kpi-item:hover .kpi-icon img {
    transform: scale(1.1);
}

.kpi {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.kpi .number {
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0.5rem;
    color: #DC6803; /* Consistent color for all numbers */
}

.kpi .text {
    color: #666;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 0.5px;
}

.loading-pulse {
    animation: pulse 1.5s infinite;
    opacity: 0.5;
}

@keyframes pulse {
    0% { opacity: 0.5; }
    50% { opacity: 1; }
    100% { opacity: 0.5; }
}

@media (max-width: 1024px) {
    .kpis {
        gap: 1.5rem;
    }

    .kpi-item {
        padding: 1.5rem;
        min-width: 240px;
    }

    .kpi .number {
        font-size: 2rem;
    }
}

@media (max-width: 768px) {
    .kpi-item {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 1rem);
        min-width: 220px;
    }

    .kpi-icon img {
        width: 3rem;
        height: 3rem;
    }
}

@media (max-width: 480px) {
    .kpi-item {
        flex: 1 1 100%;
    }

    .kpi .number {
        font-size: 1.8rem;
    }

    .kpi-icon img {
        width: 2.8rem;
        height: 2.8rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/kpi/kpi.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc,EAAE,qCAAqC;AACzD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;AACzB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;AACJ","sourcesContent":[".kpis {\n    padding: 2rem 0;\n    display: flex;\n    justify-content: space-between;\n    gap: 2rem;\n    flex-wrap: wrap;\n}\n\n.kpi-item {\n    flex: 1;\n    min-width: 280px;\n    padding: 2rem;\n    border-radius: 16px;\n    background: #FFFFFF;\n    border: 2px solid #FCCC4D;\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.kpi-item:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 20px rgba(252, 204, 77, 0.15);\n}\n\n.kpi-icon {\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.kpi-icon img {\n    width: 3.5rem;\n    height: 3.5rem;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n}\n\n.kpi-item:hover .kpi-icon img {\n    transform: scale(1.1);\n}\n\n.kpi {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.kpi .number {\n    font-size: 2.5rem;\n    font-weight: 700;\n    line-height: 1.2;\n    margin-bottom: 0.5rem;\n    color: #DC6803; /* Consistent color for all numbers */\n}\n\n.kpi .text {\n    color: #666;\n    font-size: 0.9rem;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n}\n\n.loading-pulse {\n    animation: pulse 1.5s infinite;\n    opacity: 0.5;\n}\n\n@keyframes pulse {\n    0% { opacity: 0.5; }\n    50% { opacity: 1; }\n    100% { opacity: 0.5; }\n}\n\n@media (max-width: 1024px) {\n    .kpis {\n        gap: 1.5rem;\n    }\n\n    .kpi-item {\n        padding: 1.5rem;\n        min-width: 240px;\n    }\n\n    .kpi .number {\n        font-size: 2rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .kpi-item {\n        flex: 1 1 calc(50% - 1rem);\n        min-width: 220px;\n    }\n\n    .kpi-icon img {\n        width: 3rem;\n        height: 3rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .kpi-item {\n        flex: 1 1 100%;\n    }\n\n    .kpi .number {\n        font-size: 1.8rem;\n    }\n\n    .kpi-icon img {\n        width: 2.8rem;\n        height: 2.8rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
